var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "webContent flex", on: { click: _vm.closeFontBase } },
    [
      _c("div", { staticClass: "release df cf" }, [
        _c("div", [
          _vm.type == "global"
            ? _c(
                "div",
                { staticClass: "area df", staticStyle: { width: "100%" } },
                [
                  _vm.name
                    ? _c(
                        "div",
                        {
                          staticClass: "flex",
                          on: { click: _vm.selectSection }
                        },
                        [_vm._v(_vm._s(_vm.name ? _vm.replace(_vm.name) : ""))]
                      )
                    : _c(
                        "div",
                        {
                          staticClass: "choose-tip",
                          on: { click: _vm.selectSection }
                        },
                        [
                          _c("span", [_vm._v("请选择所属的版块")]),
                          _vm._v(" "),
                          _c("img", {
                            attrs: { src: require("@/app/assets/to.png") }
                          })
                        ]
                      )
                ]
              )
            : _c("div", { staticClass: "area df" }, [
                _c("i", [_vm._v("版块：")]),
                _c("div", { staticClass: "flex" }, [
                  _vm._v(_vm._s(_vm.name ? _vm.replace(_vm.name) : ""))
                ])
              ])
        ]),
        _vm._v(" "),
        _vm.type == "aq"
          ? _c("div", { staticClass: "df" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "title flex" }, [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.title,
                      expression: "title"
                    }
                  ],
                  attrs: { puc: "", placeholder: "请提出您的问题" },
                  domProps: { value: _vm.title },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.title = $event.target.value
                    }
                  }
                })
              ])
            ])
          : _c("div", { staticClass: "title" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.title,
                    expression: "title"
                  }
                ],
                attrs: { puc: "", placeholder: "请提出您的问题" },
                domProps: { value: _vm.title },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.title = $event.target.value
                  }
                }
              })
            ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex", attrs: { id: "editorObjCts" } }),
        _vm._v(" "),
        _c("div", { staticClass: "lastFile" }, [
          _c("input", {
            attrs: { type: "file", accept: "application/pdf" },
            on: {
              change: function($event) {
                return _vm.toUploadFile($event.currentTarget)
              }
            }
          })
        ]),
        _vm._v(" "),
        _vm.fileList.length > 0
          ? _c(
              "div",
              { staticClass: "lastFileCount", on: { click: _vm.tabFileList } },
              [_vm._v(_vm._s(_vm.fileList.length) + "个附件")]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isShowFontBase,
                expression: "isShowFontBase"
              }
            ],
            staticClass: "fontBase df hao"
          },
          [
            _c("span", {
              staticClass: "flex s1",
              class: { cur: _vm.fontBase == 1 },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.tabFontBase(1)
                }
              }
            }),
            _vm._v(" "),
            _c("span", {
              staticClass: "flex s2",
              class: { cur: _vm.fontBase == 2 },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.tabFontBase(2)
                }
              }
            }),
            _vm._v(" "),
            _c("span", {
              staticClass: "flex s3",
              class: { cur: _vm.fontBase == 3 },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.tabFontBase(3)
                }
              }
            }),
            _vm._v(" "),
            _c("span", {
              staticClass: "flex s4",
              class: { cur: _vm.fontBase == 4 },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.tabFontBase(4)
                }
              }
            }),
            _vm._v(" "),
            _c("span", {
              staticClass: "flex s5",
              class: { cur: _vm.fontBase == 5 },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  return _vm.tabFontBase(5)
                }
              }
            }),
            _vm._v(" "),
            _c("i", [_vm._v("小")]),
            _vm._v(" "),
            _c("i", [_vm._v("大")])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isShowLinkBase,
                expression: "isShowLinkBase"
              }
            ],
            staticClass: "linkBase"
          },
          [
            _c("span", { staticClass: "df hao" }, [
              _vm._v("文本内容："),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.linkBaseVal1,
                    expression: "linkBaseVal1"
                  }
                ],
                staticClass: "flex",
                attrs: { puc: "", type: "text", placeholder: "请输入" },
                domProps: { value: _vm.linkBaseVal1 },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.linkBaseVal1 = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "df hao" }, [
              _vm._v("链接地址："),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.linkBaseVal2,
                    expression: "linkBaseVal2"
                  }
                ],
                staticClass: "flex",
                attrs: { puc: "", type: "text", placeholder: "请输入" },
                domProps: { value: _vm.linkBaseVal2 },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.linkBaseVal2 = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "df" }, [
              _c(
                "em",
                { staticClass: "flex", on: { click: _vm.resLinkBase } },
                [_vm._v("确认")]
              ),
              _vm._v(" "),
              _c(
                "em",
                { staticClass: "flex", on: { click: _vm.closeLinkBase } },
                [_vm._v("取消")]
              )
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isShowFileList,
                expression: "isShowFileList"
              }
            ],
            staticClass: "fileList"
          },
          _vm._l(_vm.fileList, function(v, i) {
            return _c("div", { key: i, staticClass: "fileLi df" }, [
              _c("div", { staticClass: "fileName ov-d" }, [
                _vm._v(_vm._s(v.name))
              ]),
              _vm._v(" "),
              _c("em", {
                on: {
                  click: function($event) {
                    return _vm.removeFile(i)
                  }
                }
              })
            ])
          }),
          0
        ),
        _vm._v(" "),
        _c("div", { staticClass: "tool df war hao" })
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.view.has,
              expression: "view.has"
            }
          ],
          staticClass: "view"
        },
        [
          _c(
            "div",
            { staticClass: "viewTitle", attrs: { "data-empty": "暂无标题" } },
            [_vm._v(_vm._s(_vm.view.title))]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "viewContent",
              attrs: { "data-empty": "暂无内容" },
              domProps: { innerHTML: _vm._s(_vm.view.content) }
            },
            [_vm._v(_vm._s(_vm.view.content))]
          )
        ]
      ),
      _vm._v(" "),
      _vm.confirm.has
        ? _c("div", { staticClass: "confirm df wao hao" }, [
            _c("div", { staticClass: "confirm-box" }, [
              _c("div", { staticClass: "confirm-txt df wao" }, [
                _vm._v("问题正在审核，请等待")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "confirm-end df wao hao" }, [
                _c(
                  "div",
                  {
                    staticClass: "confirm-btn",
                    on: { click: _vm.closeConfirm }
                  },
                  [_vm._v("确定")]
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isChangeSec
        ? _c("div", { staticClass: "collectBase" }, [
            _c("div", { staticClass: "collectBase-box" }, [
              _c("div", { staticClass: "collectBase-top" }, [
                _c("div", {
                  staticClass: "collectBase-close",
                  on: { click: _vm.closeCollectBase }
                })
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "collectBase-list" },
                _vm._l(_vm.sectionList, function(v, i) {
                  return _c(
                    "div",
                    {
                      key: i,
                      staticClass: "collectBase-li df cf wao",
                      class: { cur: _vm.choose.indexOf(i) >= 0 },
                      on: {
                        click: function($event) {
                          return _vm.chooseCollectBase(i)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "collectBase-title" }, [
                        _vm._v(_vm._s(v.name ? _vm.replace(v.name) : ""))
                      ])
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "collectBase-btn",
                  on: { click: _vm.resCollectBase }
                },
                [_vm._v("确认")]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.checkVisible
        ? _c("div", { staticClass: "confirm df wao hao" }, [
            _c("div", { staticClass: "confirm-box" }, [
              _c("div", { staticClass: "confirm-txt df wao" }, [
                _vm._v("内容包含敏感词："),
                _c("span", { staticStyle: { color: "#D5001C" } }, [
                  _vm._v(_vm._s(_vm.sensitiveWord))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "confirm-end df wao hao" }, [
                _c(
                  "div",
                  {
                    staticClass: "confirm-btn",
                    on: {
                      click: function($event) {
                        _vm.checkVisible = false
                      }
                    }
                  },
                  [_vm._v("确定")]
                )
              ])
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "aq" }, [_c("em", [_vm._v("追加问题")])])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35568f57", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35568f57","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/model/release/release.vue
// module id = null
// module chunks = 